import PropTypes from 'prop-types';
import { LocationProp } from './Location';

// TODO: rename to SearchSegmentProps
export const SearchSegment = PropTypes.shape({
    id: PropTypes.number.isRequired,
    origin: LocationProp,
    destination: LocationProp,
    date: PropTypes.instanceOf(Date),
    departureTime: PropTypes.string,
});

export const SearchSegmentPropsDefault = {
    id: 1,
    origin: null,
    destination: null,
    date: null,
    departureTime: null,
};
